import stringHelpers from "../../utilities/stringHelpers"
import arrayUtilities from "../../utilities/arrayUtilities"
import { Link } from "react-router-dom/cjs/react-router-dom.min"
import { toDateTimeString } from "../../utilities/dateUtilities"

export const SuspensionDisplay = ({ suspension, sites, organisationId, validityDays, sitesUpdateError }) => {

    const noSpecificValidityTimes = stringHelpers.isNullOrEmpty(suspension.enabledFromTime) || stringHelpers.isNullOrEmpty(suspension.enabledToTime)

    return (
        <div className="card-body bg-light border-top details-container">
            <div className="row">
                <div className="col-md-3 col-12  ">
                    <p className="font-weight-semi-bold  mb-3 mt-1">Name</p>
                </div>
                <div className="col-md-6 col-12 "><p className="mb-0">{ suspension.name }</p></div>
            </div>
            <div className="row">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Enabled</p>
                </div>
                <div className="col-md-6 col-12 pt-1">{suspension.isEnabled && <i className="fas fa-check text-success"></i>}{!suspension.isEnabled && <i className="fas fa-times text-danger"></i>}</div>
            </div>
            <div className="row">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Sites</p>
                </div>
                <div className="col-md-6 col-12 d-flex">
                    {
                        arrayUtilities.isNullOrEmpty(suspension.suspensionSites) && !sitesUpdateError
                        ? <p>No sites associated with this suspension. Click Edit to add</p>
                        : <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table w-100 border-bottom border-200 no-footer ">
                            <thead className="bg-200 text-900">
                                <tr>
                                    <th>Client</th>
                                    <th>Name</th>
                                    <th>Code</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    sitesUpdateError
                                    ? <tr>
                                        <td colSpan={ 3 } className="text-center py-3">
                                            <i className="fas fa-times-circle text-danger mb-2 fs-2 d-block" />
                                            <small className="text-muted">There was an error attaching sites to this suspension</small>
                                        </td>
                                      </tr>
                                    : sites
                                        .filter(item => suspension.suspensionSites.map(x => x.siteId).includes(item.id)).map(
                                            site => <tr key={ site.id }>
                                                <td>{ site.clientName }</td>
                                                <td><Link to={ `/organisation/${ organisationId }/client/${ site.clientId }/site/${ site.id }` }><h6 className="mb-0">{ site.name }</h6></Link></td>
                                                <td>{ site.siteCode }</td>
                                            </tr>
                                        )
                                }
                            </tbody>
                        </table>
                    }
                </div>
            </div>

            <hr className="border-dashed border-bottom-0"></hr>
            <h6 className="mb-3 fs-1">Date/Time Details</h6>
            <div className="row">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Start Date</p>
                </div>
                <div className="col-md-6 col-12 ">{ toDateTimeString(suspension.startDate) }</div>
            </div>
            <div className="row">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">End Date</p>
                </div>
                <div className="col-md-6 col-12 ">{ toDateTimeString(suspension.endDate) }</div>
            </div>
            <div className="row">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Suspend only on specific days</p>
                </div>
                <div className="col-md-6 col-12 ">{ validityDays.find(item => item.isEnabled) !== undefined ? <>Yes</> : <>No</> }</div>
            </div>
            {
                validityDays.find(item => item.isEnabled) !== undefined &&
                validityDays.map(
                    day => <div className="row">
                        <div className="col-md-3 col-12 ">
                            <p className="font-weight-semi-bold  mb-3">{ day.label }</p>
                        </div>
                        <div className="col-md-6 col-12 ">{ day.isEnabled ? <>Yes</> : <>No</> }</div>
                    </div>
                )
            }
            <div className="row">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Suspend only at specific times of the day</p>
                </div>
                <div className="col-md-6 col-12 ">{ noSpecificValidityTimes ? <>No</> : <>Yes</> }</div>
            </div>
            {
                !noSpecificValidityTimes
                && <div className="row">
                    <div className="col-md-3 col-12 ">
                        <p className="font-weight-semi-bold  mb-3">Time Range</p>
                    </div>
                    <div className="col-md-6 col-12 ">{ suspension.enabledFromTime.slice(0,5) } - {suspension.enabledToTime.slice(0,5)}</div>
                </div>
            }
            <hr className="border-dashed border-bottom-0"></hr>
            <div className="row">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Notes</p>
                </div>
                <div className="col-md-6 col-12 ">{ suspension.notes }</div>
            </div>
        </div>
    )
}